import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import React, { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { getQcVariant, needsTooltip, type QcVariant } from './QcStatusCell.utils';
import styles from './styles.module.css';

const VARIANT_CLASS: Record<NonNullable<QcVariant>, string> = {
  pass: styles.qcPass,
  fail: styles.qcFail,
  warning: styles.qcWarning,
  na: styles.qcNa,
};

export interface QcStatusCellProps {
  value: string | null | undefined;
  message: string | null | undefined;
}

const QcStatusCellComponent: FC<QcStatusCellProps> = ({ value, message }) => {
  const { t } = useTranslation('studies');
  const variant = getQcVariant(value);
  if (variant === null) return null;

  const circle = (
    <span aria-label={value ?? undefined} className={`${styles.qcCircle} ${VARIANT_CLASS[variant]}`} role="img" />
  );

  if (needsTooltip(variant) && message) {
    const key = variant === 'warning' ? 'qc_message_warning' : 'qc_message_fail';
    return <Tooltip content={t(key, { message })} placement="right" trigger={circle} />;
  }

  return circle;
};

export const QcStatusCell = memo(QcStatusCellComponent);
export default QcStatusCell;
